import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../core/services/data/user.service';
import { ModalService } from '../../core/services/modal.service';
import { AnalyticsService } from '../../core/services/analytics.service';

@Component({
	selector: 'app-welcome-header-widget',
	templateUrl: './welcome-header-widget.component.html',
	styleUrls: ['./welcome-header-widget.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class WelcomeHeaderWidgetComponent {
	@Input() author;

	get featuresLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/features`;
	}

	get homeLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/home`;
	}

	get isMember(): boolean {
		return (this.isPlatinumMember() || this.isGoldMember());
	}

	get authorFirstName(): string {
		return this.author?.firstName || '';
	}

	get memberRole(): string {
		return this.author?.memberRole?.roleName || '';
	}

	constructor(
		private uss: UserService,
		private router: Router,
		private ms: ModalService,
		private as: AnalyticsService,
	) {
	}

	isGoldMember() {
		return this.uss.isGoldMember();
	}

	isPlatinumMember() {
		return this.uss.isPlatinumMember();
	}

	showUpgradeModal() {
		const cta = 'upgrading';
		this.homeTracking(cta);

		this.ms.open('update-card-form');
	}

	goToDashboard(event) {
		this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
			this.router.navigate([this.homeLink]);
		});
	}

	runPromotion() {
		const cta = 'Run a Promotion';
		this.homeTracking(cta);
		this.router.navigate([this.featuresLink]);
	}

	homeTracking(cta) {
		const options = {
			section: 1,
			section_headline: `Hello ${this.authorFirstName}, Welcome to your Book Marketing Hub!`,
			cta,
		};

		this.as.homepageTracking(options);
	}
}
